import $ from 'jquery';
import 'slick-carousel';
import window from './window';

export default () => {

  $(() => {
    const $window = $(window)
    $('.headerOpen__moreButton').on('click', function () {
      $(this).toggleClass("is-active");
      $('.headerOpen__products').toggleClass("is-active");
    });

    $('.headerOpen__products__button').on('click', function () {
      $(this).toggleClass("is-active");
      $(this).next().toggleClass("is-active");
      $(".headerOpen__products__button").not(this).removeClass("is-active");
      $(".headerOpen__products__button").not(this).next().removeClass("is-active");
      // $(this).addClass("is-active");
      // $(this).next().addClass("is-active");
    });

    $('.productNavi__products__button').on('click', function () {
      $(this).toggleClass("is-active");
      $(this).next().toggleClass("is-active");
      $(".productNavi__products__button").not(this).removeClass("is-active");
      $(".productNavi__products__button").not(this).next().removeClass("is-active");
    });

    if ($('.recruit__button').length) {
      $('.recruit__button').on('click', function () {
        $(this).toggleClass("is-active");
        $(this).next().toggleClass("is-active");
      });
    }

    if ($('.interview__top').length) {
      $('.interview__top').on('click', function () {
        const targetId = $(this).attr('aria-controls');
        const $target = $(`#${ targetId }`);
        $(`[aria-controls="${ targetId }"]`).toggleClass("is-active");
        $('.interview__top').not(`[aria-controls="${ targetId }"]`).removeClass('is-active');
        $('.interviewOpen').not(`#${ targetId }`).removeClass('is-active');
        $target.toggleClass("is-active");
        if ($target.hasClass('is-active') && $window.width() <= 768) {
          $target.find('.interviewOpen__slick').slick({
            dots: false,
            lazyLoad: 'ondemand',
            centerMode: true,
            centerPadding: '74px',
            focusOnSelect: true
          });
        } else {
          $target.find('.interviewOpen__slick').slick('unslick');
        }
      });
    }

    if ($('.category--faq').length) {
      // faq navi fixed
      window.onscroll = function () {
        var faqCategory = $('.category--faq').innerHeight(); // footerの高さを取得
        var faq = $('.faq').innerHeight(); // footerの高さを取得
        var faqNaviHeight = $('.faq__navInner').innerHeight(); // footerの高さを取得
        const faqNavitop = $('.faq__nav').offset().top;
        var point = window.pageYOffset; // 現在のスクロール地点 
        if ($window.width() >= 1280) {
          if(point > faqNavitop-30){ 
            $('.faq__navInner').addClass('is-navFixed'); 
          }else{
            $('.faq__navInner').removeClass('is-navFixed'); 
          }
          if(point > faqCategory+faq-faqNaviHeight+30){ 
            $('.faq__navInner').addClass('is-navAbsolute'); 
          }else{
            $('.faq__navInner').removeClass('is-navAbsolute'); 
          }
        } else if ($window.width() >= 1000) {
          if(point > faqNavitop-50){ 
            $('.faq__navInner').addClass('is-navFixed'); 
          }else{
            $('.faq__navInner').removeClass('is-navFixed'); 
          }
          if(point > faqCategory+faq-faqNaviHeight-120){ 
            $('.faq__navInner').addClass('is-navAbsolute'); 
          }else{
            $('.faq__navInner').removeClass('is-navAbsolute'); 
          }
        }
      };
    }

    if ($('.category--products').length) {
      // product navi fixed
      window.onscroll = function () {
        var productCategory = $('.category--products').innerHeight();
        var products = $('.l-products').innerHeight();
        var productNaviHeight = $('.productNavi__products').innerHeight();
        const productNavitop = $('.productNavi').offset().top;
        var point = window.pageYOffset; // 現在のスクロール地点 
        if ($window.width() >= 1280) {
          if(point > productNavitop-30){ 
            $('.productNavi__products').addClass('is-navFixed'); 
          }else{
            $('.productNavi__products').removeClass('is-navFixed'); 
          }
          if(point > productCategory+products-productNaviHeight-170){ 
            $('.productNavi__products').addClass('is-navAbsolute'); 
          }else{
            $('.productNavi__products').removeClass('is-navAbsolute'); 
          }
        }
      };
    }

    $('.faq__button').on('click', function() {
      let $this = $(this);
      $this.toggleClass('is-active')
            .next()
            .toggleClass('is-active')
            .slideToggle();
    });

    $('.newsMenu__button').on('click', function() {
      $(this).toggleClass('is-active')
              .next()
              .toggleClass('is-active');
    });

    if ($('.interviewOpen__slick').length) {
      $('.interviewOpen__slick').on('beforeChange', slick => {
        $('.interviewOpen__slick').find('.is-loading').not('.is-loaded').addClass('is-loaded');
      });
    }

    if ($('.interviewOpen__close').length) {
      $('.interviewOpen__close').on('click', function () {
        const targetId = $(this).closest('.interviewOpen').attr('id');
        const $target = $(`#${ targetId }`);
        $target.removeClass('is-active');
        $(`[aria-controls="${ targetId }"]`).removeClass('is-active');
        if ($window.width() <= 768) {
          $target.find('.interviewOpen__slick').slick('unslick');
        }
        window.smoothScroll(`#interviewHeader`, true, 500);
      });
    }

    if ($('.l-mainvisual__box--slider').length) {
      $('.l-mainvisual__box--slider').slick({
        dots: true,
        autoplay: true,
        autoplaySpeed: 2000
      });
    }

    if ($('.details__slider').length) {
      $('.details__slider').slick({
        dots: true,
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '22px',
        focusOnSelect: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              centerMode: false,
              centerPadding: 0,
            }
          }
        ]
      });
      $('.details__slider').on('beforeChange', slick => {
        $('.details__slider').find('.is-loading').not('.is-loaded').addClass('is-loaded');
      });
    }

    $('.l-products .details h3').wrapInner("<span></span>");

  });

}